/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  // eslint-disable-next-line max-len
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}
/**
 *验证是否输入的内容是否为数字
 */
export function valiNumber(data, isNull) {
  return function(rule, value, callback) {
    if (isNull && !value) {
      return callback(new Error(`请输入${data}`))
    }
    if (value) {
      setTimeout(() => {
        if (/^\d+$/.test(value)) {
          if (value <= 0 || value > 999999999) {
            callback(new Error('请输入1-999999999的数字'))
          } else {
            callback()
          }
        } else {
          callback(new Error('请输入数字值'))
        }
      }, 10)
    } else {
      callback()
    }
  }
}
/**
 * 设置某个字段的disabled
 */
export function setDisabled(data, key, status) {
  data &&
    data.forEach(item => {
      item.rowData &&
        item.rowData.forEach(row => {
          if (row.value === key) {
            row.disabled = status
          }
        })
    })
}
/**
 * 设置某个el-form-item的required
 */
export function setRequired(data, key, status) {
  // eslint-disable-next-line no-prototype-builtins
  if (data && data.hasOwnProperty(key)) {
    data[key].length > 0 &&
      data[key].forEach(item => {
        // eslint-disable-next-line no-prototype-builtins
        if (item.hasOwnProperty('required')) {
          item.required = status
        }
      })
  }
}
/**
 * 校验保留两位小数的数值
 */
export function validDecimal(data) {
  return function(rule, value, callback) {
    if (!value) {
      return callback(new Error(`请输入数量,最多保留两位小数`))
    }
    // if (value === '0' || value === '0.0' || value === '0.00') {
    //   return callback(new Error(`请输入数量,做多保留两位小数`))
    // }
    if (/^(([0-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(value)) {
      callback()
    } else {
      callback(new Error('请输入数量,做多保留两位小数'))
    }
  }
}

/**
 * 校验保留三位小数的数值
 */
export function validDecimalThree(data) {
  return function(rule, value, callback) {
    if (!value) {
      return callback(new Error(`请输入${data},最多保留三位小数`))
    }
    if (Number(value) === 0) {
      return callback(new Error(`请输入${data},最多保留三位小数`))
    }
    if (/^(([1-9][0-9]*)|(([0]\.\d{1,3}|[1-9][0-9]*\.\d{1,3})))$/.test(value)) {
      callback()
    } else {
      callback(new Error(`请输入${data},最多保留三位小数`))
    }
  }
}

/**
 * 正负数，保留两位小数
 */
export function validDecimalForNegative(data) {
  return function(rule, value, callback) {
    if (value) {
      // if (value === '0' || value === '0.0' || value === '0.00') {
      //   return callback(new Error(`请输入${data},只能输入数字,最多保留两位小数`))
      // }
      if (/(^([-]?)[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^([-]?)(0){1}$)|(^([-]?)[0-9]\.[0-9]([0-9])?$)/.test(value)) {
        callback()
      } else {
        callback(new Error(`请输入${data},只能输入数字，最多保留两位小数`))
      }
    } else {
      callback()
    }
  }
}
/**
 * 格式化金额
 * @param {*} amount
 * @returns
 */
export const formatMoney = (amount) => {
  if (!amount) {
    return '-'
  }
  // 强制保留两位小数
  let f = parseFloat(amount)
  if (isNaN(f)) return false
  f = Math.round(amount * 100) / 100
  let s = f.toString()
  let rs = s.indexOf('.')
  if (rs < 0) {
    rs = s.length
    s += '.'
  }
  while (s.length < (rs + 1) + 2) {
    s += '0'
  }
  // 每三位用一个逗号隔开
  let leftNum = s.split('.')[0]
  const rightNum = '.' + s.split('.')[1]
  let result
  // 定义数组记录截取后的价格
  const resultArray = []
  if (leftNum.length > 3) {
    let i = true
    while (i) {
      resultArray.push(leftNum.slice(-3))
      leftNum = leftNum.slice(0, leftNum.length - 3)
      if (leftNum.length < 4) {
        i = false
      }
    }
    // 由于从后向前截取，所以从最后一个开始遍历并存到一个新的数组，顺序调换
    const sortArray = []
    for (let m = resultArray.length - 1; m >= 0; m--) {
      sortArray.push(resultArray[m])
    }
    result = leftNum + ',' + sortArray.join(',') + rightNum
  } else {
    result = s
  }
  return result
}
